import {tns} from 'tiny-slider/src/tiny-slider.module';

export const initAccommodationSlider = () => {
    for (const slider of [...document.getElementsByClassName('accommodation-slider__inner'), ...document.getElementsByClassName('region-resort-slider__inner')]) {
        let sliderContainer = slider.getElementsByClassName('accommodation-slider__slide-container')[0];
        if(!sliderContainer || sliderContainer.length === 0) {
            sliderContainer = slider.getElementsByClassName('region-resort-slider__slide-container')[0];
        }
        const autoplay = document.getElementById('auto-scroll-flag') !== null;

        const tinyslider = tns({
            container: sliderContainer,
            autoplay,
            autoplayButtonOutput: false,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            items: 1,
            controls: true,
            mouseDrag: true,
            nav: false,
            lazyload: true,
            controlsContainer: slider.getElementsByClassName('accommodation-slider__controls')[0] ||  slider.getElementsByClassName('region-resort-slider__controls')[0]
        });
        slider.style.height = 'auto';
    }
};
